import { render, staticRenderFns } from "./Bubble.vue?vue&type=template&id=eef4d60c&scoped=true"
import script from "./Bubble.vue?vue&type=script&lang=js"
export * from "./Bubble.vue?vue&type=script&lang=js"
import style0 from "./Bubble.vue?vue&type=style&index=0&id=eef4d60c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eef4d60c",
  null
  
)

export default component.exports